import React from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'
import 'src/assets/scss/psaCustomCss.css'

const useStyles = makeStyles(() => ({
  logoSection: {
    width: '100%',
    backgroundColor: 'transparent',
    padding: '3px 33px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  crimsonLogo: {
    height: 40,
    width: 'auto',
  },
  blackSection: {
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 1.0)',
    boxShadow: '0 2px 2px 0 rgb(0 0 0 / 25%)',
    padding: '3px 30px',
  },
  footerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  linksContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
  },
  linkText: {
    cursor: 'pointer',
    color: '#F8F8F8',
    fontWeight: '600 !important',
    textDecoration: 'underline',
    fontSize: '12px !important',  
    fontFamily: "'Open Sans', sans-serif !important", 
    lineHeight: '16px !important',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  poweredBy: {
    color: '#F8F8F8',
    fontWeight: '600 !important',
    fontSize: '12px  !important', 
    fontFamily: "'Open Sans', sans-serif !important",
    lineHeight: '16px !important',
    textAlign: 'right',
  },
}))

function Footer() {
  const classes = useStyles()

  function openWindow(newPath) {
    window.open(newPath, '_blank', 'noreferrer')
  }

  return (
    <>
      <Box className={classes.logoSection}>
        <img
          src={`${process.env.PUBLIC_URL}/static/logo.jpg`}
          alt="CrimsonLogic"
          className={classes.crimsonLogo}
        />
      </Box>

      <Box className={classes.blackSection}>
        <Box className={classes.footerContent}>
          <Box className={classes.linksContainer}>
            <Typography
              className={classes.linkText}
              onClick={() => openWindow('https://www.psahalifax.com/s/')}
            >
              Home
            </Typography>
            <Typography
              className={classes.linkText}
              onClick={() => openWindow('https://www.psahalifax.com/s/company-info')}
            >
              About Us
            </Typography>
            <Typography
            className={classes.linkText}
            onClick={() => openWindow('https://www.psahalifax.com/s/company-info/contact-us')}>
            Contact Us
            </Typography>
            <Typography
              className={classes.linkText}
              onClick={() =>
                openWindow(
                  'https://prod-api.psahalifax.com/fc/PSA_Halifax_General_Trading_Terms_Conditions.pdf'
                )
              }
            >
              Terms and Conditions
            </Typography>
          </Box>

          <Typography className={classes.poweredBy}>
            Powered by CrimsonLogic
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default Footer
